<template>
  <div>
    <div v-if="loading">
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <!-- <div class="row">
          
        </div> -->
        <div class="row">
          <div class="col-md-7">
            <h3>
              {{ isEditing ? "ACTUALIZAR PROGRAMA" : "GENERAR PROGRAMA" }}
            </h3>
            <div >
              <!-- FUNCIONANDO  -->
              Ingrese fecha:
              <date-picker
                v-model="programa_retiro.fecha"
                format="DD-MM-YYYY"
                :editable="false"
                :clearable="false"
                value-type="YYYY-MM-DD"
                :disabled-date="
                  date => {
                    const yesterday = new Date(Date.now() - 86400000);
                    return date < yesterday;
                  }
                "
              ></date-picker>
              <label
                class="text-error"
                v-text="getValidationText(`fecha`)"
              ></label>
            </div>
          </div>
          <div class="col-md-3">
            <table class="table-especies">
              <tr>
                <th>Especie</th>
                <th>Porcentaje</th>
              </tr>
              <tr v-for="columna in listas.pr_especies">
                <td>{{ columna.nombre }}</td>
                <td>{{ especies[columna.id] || '0' }}%</td>
              </tr>
            </table>
          </div>
          <div class="col-md-2 buttons">
            <button @click="agregarFila" class="add-row">Agregar Fila</button>
            <button @click="volver" class="return">Volver</button>
          </div>
        </div>
        <div class="row mt-3 pr-table-container">
          <table class="table table-bordered">
            <tr class="background-columnas">
              <th class="label-columnas" v-for="columna in columnas_pr">
                {{ columna.text }}
              </th>
              <th>Acciones</th>
            </tr>
            <tr v-for="(item, i) in programa_retiro.detalle">
              <td v-for="columna in columnas_pr">
                <template v-if="columna.type === 'time'">
                  <!-- HORA -->
                  <label class="fecha-label">{{ fechaSeleccionada }}</label>
                  <date-picker
                    style="width: 80px;"
                    v-model="item[columna.value]"
                    value-type="YYYY-MM-DD HH:mm"
                    format="HH:mm"
                    :editable="false"
                    :clearable="false"
                    :type="columna.type"
                    :disabled-date="disabledPreviousDates"
                  ></date-picker>
                </template>
                <template v-else-if="columna.type === 'datetime'">
                  <!-- FECHA Y HORA -->
                  <date-picker
                    style="width: 160px;"
                    v-model="item[columna.value]"
                    format="DD-MM-YYYY HH:mm"
                    value-type="YYYY-MM-DD HH:mm:ss"
                    :editable="false"
                    :clearable="false"
                    :type="columna.type"
                    :disabled-date="disabledPreviousDates"
                    :disabled-time="
                      date => disableTime(date, item.fecha_hora_retiro)
                    "
                  ></date-picker>
                </template>
                <template v-else-if="columna.type === 'select'">
                  <v-select
                    v-model="item[columna.value]"
                    :reduce="item => item.id"
                    class="custom-select"
                    :options="listas[columna.options_name]"
                    :label="columna.options_label"
                    :append-to-body="true"
                    :style="{minWidth: columna.minWidth}"
                  >
                  </v-select>
                </template>
                <template v-else-if="columna.type === 'textarea'">
                  <textarea class="textarea" cols="30" rows="2" v-model="item[columna.value]">
                  </textarea>
                </template>
                <template v-else>
                  <input
                    class="input"
                    :type="columna.type"
                    v-model="item[columna.value]"
                  />
                </template>
                <label
                  class="text-error"
                  v-text="getValidationText(`detalle.${i}.${columna.value}`)"
                ></label>
              </td>
              <td>
                <button
                  @click="eliminarFila(i)"
                  type="button"
                  class="btn-danger btn-delete"
                >
                  Eliminar Fila
                </button>
              </td>
            </tr>
          </table>
        </div>
        <label class="text-error" v-text="getValidationText(`detalle`)"></label>

        <div class="rowr">
          <button @click="registrarPrograma" class="register">
            <!-- Registrar -->
            {{ isEditing ? "Actualizar" : "Registrar" }}
          </button>
          <div class="resend" v-if="isEditing">
            <input type="checkbox" id="reenviar" v-model="reenviar">
            <label for="reenviar">Reenviar correo electrónico</label>
          </div>
        </div>
      </div>
    </div>
    <div id="swal-container"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      loading: true,
      programa_retiro: {
        fecha: new Date().toISOString().split("T")[0],
        detalle: []
      },
      reenviar: false,
      validationErrors: {},
      listas: {
        pr_plantas: [],
        pr_proveedores: [],
        pr_tipo_estanque: [],
        pr_productos: [],
        pr_especies: [],
        transportes: [],
        procedencias: []
      },
      columnas_pr: [
        {
          text: "Planta",
          value: "pr_plantas_id",
          type: "select",
          options_name: "pr_plantas",
          options_label: "nombre"
        },
        {
          text: "Procedencia",
          value: "procedencia_id",
          type: "select",
          options_name: "procedencias",
          options_label: "nombre"
        },
        {
          text: "Proveedor",
          value: "pr_proveedores_id",
          type: "select",
          options_name: "pr_proveedores",
          options_label: "nombre"
        },
        {
          text: "Fecha retiro",
          value: "fecha_hora_retiro",
          type: "time"
        },
        {
          text: "Camión",
          value: "transportes_id",
          type: "select",
          options_name: "transportes",
          options_label: "patente",
          minWidth: "100px",
        },
        {
          text: "Tipo estanque",
          value: "pr_tipo_estanque_id",
          type: "select",
          options_name: "pr_tipo_estanque",
          options_label: "nombre",
          minWidth: "100px",
        },
        {
          text: "Horas",
          value: "horas",
          type: "number"
        },
        {
          text: "ETA",
          value: "fecha_hora_llegada",
          type: "datetime"
        },
        {
          text: "KG Est.",
          value: "kg_estimados",
          type: "number"
        },
        {
          text: "Productos",
          value: "pr_productos_id",
          type: "select",
          options_name: "pr_productos",
          options_label: "nombre",
          minWidth: "150px",
        },
        {
          text: "Especies",
          value: "pr_especies_id",
          type: "select",
          options_name: "pr_especies",
          options_label: "nombre",
          minWidth: "150px",
        },
        {
          text: "Carga Bins",
          value: "carga_bins",
          type: "textarea"
        },
        {
          text: "Motivo",
          value: "motivo",
          type: "textarea"
        }
      ]
    };
  },

  async mounted() {
    if (this.$route.params.id_copia) {
      const programa = await this.cargarPrograma(this.$route.params.id_copia);
      if (programa.data) {
        this.programa_retiro = this.limpiarDatos(programa.data);
      }
    }

    if (this.$route.params.id) {
      const programa = await this.cargarPrograma(this.$route.params.id);
      if (!programa.data) {
        this.$router.push("/programa_retiro/generar");
      } else {
        this.programa_retiro = programa.data;
      }
    }
    
    this.cargarDatos("programa_retiro/especies", "pr_especies");
    this.cargarDatos("programa_retiro/plantas", "pr_plantas");
    this.cargarDatos("programa_retiro/productos", "pr_productos");
    this.cargarDatos("programa_retiro/proveedores", "pr_proveedores");
    this.cargarDatos("programa_retiro/tipos_estanques", "pr_tipo_estanque");
    this.cargarDatos("transportes?limit=1000", "transportes", true);
    this.cargarDatos("comunas?limit=1000", "procedencias", true);
  },

  methods: {
    agregarFila() {
      const detalle = this.programa_retiro.detalle;
      const nuevo_detalle = {
        pr_plantas_id: null,
        procedencia_id: null,
        pr_proveedores_id: null,
        fecha_hora_retiro: "",
        transportes_id: null,
        pr_tipo_estanque_id: null,
        horas: 1,
        fecha_hora_llegada: "",
        kg_estimados: 0,
        pr_productos_id: null,
        pr_especies_id: null,
        carga_bins: "",
        motivo: ""
      };
      detalle.push(nuevo_detalle);
    },
    async eliminarFila(i) {
      const result = await Swal.fire({
        title: "¿Estás seguro de querer eliminar esta fila?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5e72e4",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
      });

      if (result.isConfirmed) {
        // Eliminar la fila aquí
        const detalle = this.programa_retiro.detalle;
        detalle.splice(i, 1);
      }
    },
    async cargarDatos(url, list_value, paginated) {
      await this.axios
        .get(`${this.api}/${url}`, this.cabeceras_json)
        .then(res => {
          if (paginated) {
            this.listas[list_value] = res.data.data.data;
            this.loading = false;
            return;
          }
          this.listas[list_value] = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    cargarPrograma(id) {
      const url = `${this.api}/programa_retiro/${id}`;
      return this.axios
        .get(url, this.cabeceras_json)
        .then(res => {
          return res.data.data;
        })
        .catch(e => {
          console.log(e);
          return null;
        });
    },
    disableTime(date, fecha_hora_retiro) {
      // Convertir la fecha y hora de retiro a un objeto Date
      const retiro = new Date(
        `${this.programa_retiro.fecha} ${fecha_hora_retiro.substring(11)}`
      );

      // Si la fecha de retiro es anterior a la fecha actual, deshabilitarla
      if (retiro.getDate() != date.getDate()) {
        return false;
      }
      if (retiro.getHours() >= date.getHours()) return true;
      return false;
    },

    disabledPreviousDates(date) {
      const fecha = new Date(this.programa_retiro.fecha); // bloqueo dias ETA calendario, segun fecha registro
      return date < fecha;
    },

    getValidationText(key) {
      return this.validationErrors[key]
        ? this.validationErrors[key].join(", ")
        : "";
    },

    async registrarPrograma() {
      const data = this.programa_retiro;

      if (this.isEditing) {
        const result = await Swal.fire({
          title: `Actualizar este programa, ${this.reenviar ? '' : 'no ' } reenviará el correo electrónico`,
          text: `Para ${this.reenviar ? 'no' : 'sí' } reenviarlo, pulse en 'cancelar' y ${this.reenviar ? 'desmarque' : 'marque' } la opción correspondiente`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#5e72e4",
          cancelButtonColor: "#d33",
          confirmButtonText: "Actualizar",
          cancelButtonText: "Cancelar"
        });

        if (!result.isConfirmed) {
          return;
        }
        data.reenviar = this.reenviar;
      }

      this.loading = true;
      const url = `${this.api}/programa_retiro`;

      data.detalle = data.detalle.map(item => {
        return {
          ...item,

          fecha_hora_retiro: `${
            this.programa_retiro.fecha
          } ${item.fecha_hora_retiro.substring(11)}`
        };
      });

      await this.axios
        .post(url, data, this.cabeceras_json)
        .then(res => {
          this.validationErrors = {};
          if (!this.$route.params.id) {
            const id = res.data.data.id;
            this.$router.push(`/programa_retiro/generar/${id}`);
          }
          const programa_retiro_registrado = res.data.data;
          Object.assign(this.programa_retiro, programa_retiro_registrado);

          // Modal readyyyyyy
          Swal.fire({
            icon: "success",
            title: res.data.mensaje,
            showConfirmButton: false,
            timer: 1500
          });
        })
        .catch(e => {
          if (e.response.status === 400) {
            this.validationErrors = e.response.data.data;
          } else {
            // Mostrar un mensaje genérico de error
            Swal.fire({
              icon: "error",
              title: "¡Error!",
              text: "Ha ocurrido un error al registrar programa de retiro",
              confirmButtonColor: "#2dce89"
            });
            console.error(e);
          }
        });
      this.loading = false;
    },

    validateEmptyFields(data, excludedFields) {
      // Recorre las propiedades del objeto data
      for (const property in data) {
        // Si la propiedad está en la lista de campos excluidos, se ignora
        if (excludedFields.includes(property)) {
          continue;
        }

        // Si una propiedad es un objeto anidado, se valida recursivamente
        if (typeof data[property] === "object") {
          if (this.validateEmptyFields(data[property], excludedFields)) {
            return true;
          }
        } else {
          // Si el valor de la propiedad es una cadena vacía, se retorna true
          if (data[property] === "") {
            return true;
          }
        }
      }
      // Si no se encuentran campos vacíos, se retorna false
      return false;
    },
    volver() {
      this.$router.push("/programa_retiro/listado");
    },
    limpiarDatos(programa_retiro) {
      const programa_retiro_limpio = {};
      programa_retiro_limpio.fecha = programa_retiro.fecha;
      programa_retiro_limpio.detalle = programa_retiro.detalle.map(item => {
        const {id, finalizado, created_at, updated_at, ...newItem} = item;
        return newItem;
      });
      return programa_retiro_limpio;
    }
  },
  computed: {
    ...mapState(["api", "api_public", "cabeceras_json", "token"]),
    fechaSeleccionada() {
      if (this.programa_retiro.fecha) {
        const fecha = new Date(this.programa_retiro.fecha);
        fecha.setDate(fecha.getDate() + 1); // suma un dia
        const dia = fecha
          .getDate()
          .toString()
          .padStart(2, "0");
        const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
        const anio = fecha.getFullYear();
        return `${dia}/${mes}/${anio}`;
      } else {
        return "";
      }
    },
    isEditing() {
      return this.$route.params.id;
    },
    especies() {
      let total = 0;
      const especies_kgs = this.programa_retiro.detalle.reduce((especies, item) => {
        if (!especies[item.pr_especies_id]) especies[item.pr_especies_id] = 0;
        let kg_estimados = parseInt(item.kg_estimados);
        
        if (isNaN(kg_estimados)) {
          kg_estimados = 0;
        }
        
        total += kg_estimados;
        especies[item.pr_especies_id] += kg_estimados; 
        return especies;
      }, {});

      for (const especie in especies_kgs) {
        if (isNaN(especies_kgs[especie])) continue;
        especies_kgs[especie] = Math.round(especies_kgs[especie] / total * 10000) / 100;
      }

      return especies_kgs;
    }
  }
};
</script>

<style scoped>
.pr-table-container {
  overflow: auto;
}
.background-columnas {
  color: #fff;
  background-color: #468faf;
}

.label-columnas {
  font-family: inherit;
  font-size: 0.7rem;
  letter-spacing: 1px;
  font-weight: 550;
}
.custom-select {
  min-width: 190px;
  width: max-content;
  height: calc(1.5em + 1.25rem + 2px);
  border: 0px;
  padding: 0%;
  background: fixed;
  display: block;
}

.rowr {
  padding-top: 10px;
  display: flex;
  gap: 2rem;
}

.btn-delete {
  font-family: inherit;
  letter-spacing: 0.025em;
  border: 1px solid transparent;
  padding: 0.25rem 0.5rem;
  border: none;
  border-radius: 3px;
}

.btn-delete:focus {
  outline: none;
}

.btn-delete {
  transition: transform 0.2s ease-in-out;
}

.btn-delete:hover {
  transform: translateY(-1px); /* Mueve 5px hacia arriba */
}

.add-row {
  font-family: inherit;
  color: #fff;
  border-color: #2dce89;
  background-color: #2dce89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  border: 1px solid transparent;
  letter-spacing: 0.01em;
  text-transform: none;
  font-size: 0.8rem;
  font-weight: 550;
  padding: 0.625rem 1.25rem;
}

.add-row:focus {
  outline: none;
}

.add-row {
  transition: transform 0.2s ease-in-out;
}

.add-row:hover {
  transform: translateY(-1px); /* Mueve 5px hacia arriba */
}

.return {
  font-family: inherit;
  color: #fff;
  border-color: #5e72e4;
  background-color: #5e72e4;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  border: 1px solid transparent;
  letter-spacing: 0.025em;
  text-transform: none;
  font-size: 0.8rem;
  font-weight: 550;
  padding: 0.625rem 1.25rem;
}
.return:focus {
  outline: none;
}

.return {
  transition: transform 0.2s ease-in-out;
}

.return:hover {
  transform: translateY(-1px); /* Mueve -1px hacia arriba */
}

.register {
  font-family: inherit;
  color: #fff;
  border-color: #2dce89;
  background-color: #2dce89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  border: 1px solid transparent;
  letter-spacing: 0.025em;
  text-transform: none;
  font-size: 0.8rem;
  font-weight: 550;
  padding: 0.625rem 1.25rem;
}
.register:focus {
  outline: none;
}

.register {
  transition: transform 0.2s ease-in-out;
}

.register:hover {
  transform: translateY(-1px); /* Mueve 5px hacia arriba */
}
.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  display: inline-block;
  width: 70px;
  height: 70px;
  border: 8px solid #fff;
  border-radius: 50%;
  border-top-color: #5e72e4;
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.fecha-label {
  font-weight: bold;
  margin-right: 10px;
  font-weight: bold;
}

.text-error {
  color: red;
  display: block;
}

.input {
  min-width: 3rem;
  width: 50%;
  padding: 0.2rem;
  margin-bottom: 0.5rem;
  border-radius: 0.3rem;
}

.textarea {
  resize: vertical;
  width: 16rem;
  padding: 0.2rem;
  margin-bottom: 0.5rem;
  border-radius: 0.3rem;
  min-height: 48px;
  max-height: 12rem;
}

.input, .textarea {
  border: #ccc 1px solid;
}

.input:focus, .input:hover,
.textarea:focus, .textarea:hover {
  outline: none;
  border: #409aff 1px solid;
}

.resend {
  display: flex;
  gap: 0.4rem;
  align-items: center;
  justify-content: center;
}

.resend label {
  margin: 0;
}

.resend label,
.resend input {
  cursor: pointer;
}

.table-especies td, .table-especies th {
  padding: 0.2rem 0.7rem;
  border: black solid 1px;
}

.buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
}

</style>
